import { Link } from "react-router-dom";
import { ShoppingCart, ArrowUpRight } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { useCart } from "@/lib/cart";
import { imgUrl } from "@/lib/api";
import { BrandBadge, StockBadge, PremiumBadge, SaleBadge, GiftBadge } from "@/components/shop/Badges";
import { NetPrice } from "@/components/shop/Totals";
import { CompareToggle } from "@/components/shop/Compare";

export const ProductCard = ({ p, i = 0 }) => {
  const { t } = useLang();
  const { add } = useCart();
  return (
    <div data-testid={`product-card-${p.id}`} style={{ animationDelay: `${i * 60}ms` }}
      className="rise group relative flex flex-col bg-[#30354A] border border-[#3B4157] hover:border-orange-500/70 transition-colors">
      <Link to={`/product/${p.id}`} className="relative block aspect-square overflow-hidden img-stage" data-testid={`product-card-link-${p.id}`}>
        {p.images?.[0] && (
          <img src={imgUrl(p.images[0])} alt={p.name} loading="lazy"
            className="w-full h-full object-contain p-6 transition-transform duration-500 group-hover:scale-105" />
        )}
        <div className="absolute top-3 left-3 flex flex-col items-start gap-1.5"><BrandBadge brand={p.brand} />{p.gift_lt && <GiftBadge testid={`product-card-gift-${p.id}`} />}</div>
        {p.premium !== false && <div className="absolute bottom-3 left-3"><PremiumBadge /></div>}
        {p.old_price > p.price && <div className="absolute bottom-3 right-3"><SaleBadge pct={p.discount_pct} testid={`product-card-sale-${p.id}`} /></div>}
        <ArrowUpRight className="absolute top-3 right-3 w-5 h-5 text-white/0 group-hover:text-orange-500 transition-colors" />
      </Link>
      <div className="flex flex-col flex-1 p-4 gap-3">
        <div className="flex items-center justify-between gap-2">
          <span className="text-[10px] font-mono-x uppercase tracking-wider text-slate-500">{t(p.machine_type)} · {t(p.suspension)}</span>
          <CompareToggle id={p.id} className="text-[10px]" />
        </div>
        <Link to={`/product/${p.id}`} className="font-display font-bold text-xl uppercase leading-tight hover:text-orange-500 transition-colors">
          {p.name}
        </Link>
        {p.fits ? <div data-testid={`product-card-fits-${p.id}`} className="text-xs"><span className="text-slate-500">{t("fits_label")}:</span> <span className="text-orange-400">{p.fits}</span> <span className="text-slate-600 font-mono-x">· {p.sku}</span></div>
          : <StockBadge stock={p.stock} testid={`product-card-stock-${p.id}`} />}
        <div className="mt-auto flex items-end justify-between pt-2">
          {p.price_on_request ? (
            <Link to={`/product/${p.id}`} data-testid={`product-card-ask-${p.id}`} className="font-display font-bold uppercase text-orange-500 hover:text-orange-400">{t("ask_price")} →</Link>
          ) : (<>
          <NetPrice value={p.price} old={p.old_price} testid={`product-card-price-${p.id}`} className="font-display font-black text-2xl" />
          <button data-testid={`product-card-add-${p.id}`} onClick={() => add(p)}
            className="grid place-items-center w-10 h-10 bg-orange-500 text-[#1F2230] hover:bg-orange-400 disabled:bg-slate-700 disabled:text-slate-500 transition-colors"
            title={t("add_cart")}>
            <ShoppingCart className="w-4 h-4" />
          </button>
          </>)}
        </div>
      </div>
    </div>
  );
};
